import { render } from "./riskUpdate.vue?vue&type=template&id=6f848570"
import script from "./riskUpdate.vue?vue&type=script&lang=js"
export * from "./riskUpdate.vue?vue&type=script&lang=js"

import "./riskUpdate.vue?vue&type=style&index=0&id=6f848570&lang=less"
script.render = render

export default script